var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"primary ticket-view app-navigation-view"},[_c('div',{staticStyle:{"width":"500px","margin":"30px auto"}},[_c('span',{attrs:{"id":"hubspotForm"}})])])
}]

export { render, staticRenderFns }